export default "__VITE_ASSET__78650cb4__"